import { Components, Theme } from '@mui/material';

export const getMuiIconButton = (
  theme: Theme,
): Components['MuiIconButton'] => ({
  defaultProps: {
    color: 'primary',
    disableRipple: true,
  },

  styleOverrides: {
    root: {
      textTransform: 'none',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      border: `2px solid ${theme.palette.background.default}`,
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
        borderColor: theme.palette.grey[100],
      },
    },

    sizeLarge: {
      width: 48,
      height: 48,
      borderRadius: theme.shape.borderRadius, // ex 17
      '& > svg': {
        fontSize: 24,
      },
    },
    sizeMedium: {
      width: 40,
      height: 40,
      borderRadius: theme.shape.borderRadiusMd, // ex 14,
      '& > svg': {
        fontSize: 24,
      },
    },
    sizeSmall: {
      width: 32,
      height: 32,
      borderRadius: theme.shape.borderRadiusMd, // ex 11,
      '& > svg': {
        fontSize: 20,
      },
    },
  },
  variants: [
    {
      props: { size: 'extraLarge' },
      style: {
        width: 60,
        height: 60,
        borderRadius: theme.shape.borderRadiusXl,
        '& > svg': {
          fontSize: 28,
        },
      },
    },
    {
      props: { size: 'extraSmall' },
      style: {
        width: 24,
        height: 24,
        borderRadius: theme.shape.borderRadiusSm,
        '& > svg': {
          fontSize: 20,
        },
      },
    },

    {
      props: { color: 'primary' },
      style: {
        color: theme.palette.primary.main,
      },
    },
    {
      props: { color: 'secondary' },
      style: {
        color: theme.palette.grey[600],
      },
    },
    {
      props: { color: 'info' },
      style: {
        color: theme.palette.info.main,
      },
    },
    {
      props: { color: 'error' },
      style: {
        color: theme.palette.error.main,
      },
    },
    {
      props: { color: 'warning' },
      style: {
        color: theme.palette.warning.main,
      },
    },
    {
      props: { disabled: true },
      style: {
        '&&': {
          color: theme.palette.grey[400],
          backgroundColor: theme.palette.grey[100],
          '&:hover': {
            backgroundColor: theme.palette.warning.dark,
          },
        },
      },
    },
  ],
});
